import React from 'react'

// Tutup panel melayang saat klik di luar elemen yang dirujuk `ref`.
// Diekstrak dari ExportMenu supaya CardMenu (StatCard) bisa memakai
// mekanisme yang sama tanpa menggandakan listener mousedown-nya.
export function useClickOutside(open, setOpen) {
  const ref = React.useRef(null)

  React.useEffect(() => {
    if (!open) return
    function handle(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handle)
    return () => document.removeEventListener('mousedown', handle)
  }, [open, setOpen])

  return ref
}
